import BaseService from "./base.service";
const service = new BaseService("/projects/:id/project_analysis")

service.availableModels = function(config){
  const path = this._getResource() + '/available_models'
  return this.http.get(path, config);
}

service.reset = function(payload){
  const path = this._getResource() + '/reset_project_analysis'
  return this.http.post(path, payload);
}

export default service;